var map = {
	"./homepage.de-CH.json": 1329,
	"./homepage.de-DE.json": 1330,
	"./homepage.en-CA.json": 1331,
	"./homepage.en-GB.json": 1332,
	"./homepage.en-IN.json": 1333,
	"./homepage.en-ME.json": 1334,
	"./homepage.en-US.json": 1335,
	"./homepage.es-EM.json": 1336,
	"./homepage.es-ES.json": 1337,
	"./homepage.fr-BE.json": 1338,
	"./homepage.fr-CA.json": 1339,
	"./homepage.fr-CH.json": 1340,
	"./homepage.nl-BE.json": 1341,
	"./homepage.nl-NL.json": 1342,
	"./homepage.pl-PL.json": 1343,
	"./homepage.pt-BR.json": 1344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1328;